import React from "react";
import PropTypes from "prop-types";

import "./OkCSSLoader.scss";

// New loader with same API as old, but using just CSS.
const OkCSSLoader = ({ className, show, color: borderColor, size }) => {
	if (!show) return null;

	const parentStyle = {
		width: size,
		height: size,
		borderColor,
		borderTopColor: "transparent",
	};

	return (
		<div className={`ok-css-loader ${className}`} style={parentStyle} />
	);
};
OkCSSLoader.Size = {
	xtiny: 30,
	tiny: 36,
	xsmall: 44,
	small: 52,
	medium: 60,
	large: 68,
};

OkCSSLoader.propTypes = {
	className: PropTypes.string,
	show: PropTypes.bool,
	color: PropTypes.string,
	size: PropTypes.number,
};
OkCSSLoader.defaultProps = {
	className: "",
	show: false,
	color: "#3260c7",
	size: OkCSSLoader.Size.medium,
};

export default OkCSSLoader;



// WEBPACK FOOTER //
// ./src/shared/components/OkCSSLoader.jsx